import type { Movie } from '@/types/movie';
import MovieCard from '@/components/feature/MovieCard';

interface MovieGridProps {
  movies: Movie[];
  showHeat?: boolean;
  columns?: 4 | 5 | 6;
}

const columnMap = {
  4: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4',
  5: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5',
  6: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6',
};

export default function MovieGrid({ movies, showHeat = false, columns = 6 }: MovieGridProps) {
  return (
    <div className={`grid ${columnMap[columns]} gap-x-3 gap-y-6 md:gap-x-4 md:gap-y-8`}>
      {movies.map((movie) => (
        <MovieCard key={movie.id} movie={movie} showHeat={showHeat} />
      ))}
    </div>
  );
}